export const buildTemplatePayload = (
  templateLike,
  { includeId = true, overrides = {} } = {}
) => {
  if (!templateLike || typeof templateLike !== 'object') return null;

  const {
    id,
    ownerId,
    owner_id,
    ownerUsername,
    owner,
    User,
    Event,
    createdAt,
    updatedAt,
    created_at,
    updated_at,
    ...rest
  } = templateLike;

  const payload = {
    ...rest,
    ...overrides,
  };

  const validId =
    includeId &&
    id !== undefined &&
    id !== null &&
    id !== 'null' &&
    id !== 'none';
  if (validId) {
    payload.id = id;
  } else {
    delete payload.id;
  }

  delete payload.ownerId;
  delete payload.owner_id;
  delete payload.ownerUsername;
  delete payload.owner;
  delete payload.User;
  delete payload.Event;
  delete payload.createdAt;
  delete payload.updatedAt;
  delete payload.created_at;
  delete payload.updated_at;

  // Drop stale serialized blocks; backend rebuilds data from the
  // flattened fields we send alongside the request. Keeping these
  // copies caused new templates to inherit the previous template's
  // defaults (e.g. the Regmail baseline) when saving.
  delete payload.data;
  delete payload.regmail;

  return payload;
};
